import { Component, OnInit, EventEmitter } from '@angular/core';
import { TableConfiguration, TableColumns, SessionService, MessageService, HttpService, LocalStorageService, MenuBreadCrumb, HeaderFilters } from 'brainloper-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { Activity } from 'app/models2/maintenance/activity';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { EventService } from 'app/services/event.service';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit {


  public urlTableActivities: string = `${EndpointDictionary.Activity.ACTIVITY_TABLE}`
  private urlPostActividades: string = `${EndpointDictionary.Activity.CRUD_ACTIVITY_DATA}` //Delete,Update,Post
  private urlComboEquipment : string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`
  private urlComboTypeEquipment : string = `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_COMBO}`

  public titleActividades: string = 'Actividades'
  public recargarTablaActividades = new EventEmitter<any>()
  public dataActividades: Array<Activity> = []
  public configurationActividades: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
  }
  public columnasActividades: TableColumns<Activity>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'equipmentType',
      label: 'Tipo equipo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'odometerFrequency',
      label: 'Frecuencia (odómetro/horómetro)',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'timeFrequency',
      label: 'Frecuencia (días)',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'lastMttoDate',
      label: 'Fecha próximo mantenimiento:',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'cost',
      label: 'Costo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    }
  ]


  public headerFilters: Array<HeaderFilters> = [
    {
      tN: "equipos",
      labelFilter:"Equipo",
      urlData: this.urlComboEquipment,
      visibleField:"code",
      primaryKey:"id",
      type:"select",
      value:""
    },   {
      tN: "tipo_equipo",
      labelFilter:"Tipo equipo",
      urlData: this.urlComboTypeEquipment,
      visibleField:"name",
      primaryKey:"id",
      type:"select",
      value:""
    }
  ]

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Actividades",
      current:true
    }
  ]
  constructor(
    private session: SessionService,
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private deleteItem: DeleteGenericService,
    private storage : LocalStorageService,
    private eventService : EventService
  ) {
   }

  ngOnInit(): void {
  }

  openModal() {
  }

  addActivity() {
    this.session.setData('redirect', 'new')
    this.router.navigate(["detalle"], { relativeTo: this.activeRoute })
  }

  async editActivity($event:Activity[]) {

    var data: Activity
    var res: Array<Activity> = await this.http.getDataBody(`${this.urlPostActividades}/${$event[0].id}`)
    if (res) {
      data = res[0]
      this.session.setData('redirect', 'edit')
      this.session.setData("dataActivity",data)
      this.router.navigate(["detalle"], { relativeTo: this.activeRoute })
    }

  }
  async deleteActivity($event:Activity[]) {
    await this.deleteItem.deleteD($event, this.urlPostActividades, "id", "Actividad ", "Actividades")
        this.recargarTablaActividades.emit()
  }



  ngOnDestroy(){
  }


}
